import React from 'react';
import cn from 'classnames';
import { IScheduleDemoFormValues } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoForm/interfaces';
import ScheduleDemoContext, { useScheduleDemoContext } from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoContext';
import ScheduleDemoForm from '@framework/ui/Organisms/ScheduleDemo/ScheduleDemoForm';
import ScheduleDemoFormSuccess from './ScheduleDemoFormSuccess';
import Modal from '@dealroadshow/uikit-modal';
import { ColorType, ILogoProps } from '@dealroadshow/uikit-logo/types';
import Spinner from '@dealroadshow/uikit-loader/Spinner';

import waves from './assets/waves.svg';
import styles from './scheduleDemoModal.module.scss';

interface IProps {
  tenant: string,
  logoComponent: React.ComponentType<ILogoProps>,
  defaultPhoneCountry?: string,
  getInitialFormValues?: () => IScheduleDemoFormValues | null,
  closeModal?: () => void,
  afterClose?: () => void,
}

const ScheduleDemoModal = ({
  tenant,
  defaultPhoneCountry,
  getInitialFormValues,
  closeModal,
  afterClose,
  logoComponent: LogoComponent,
}: IProps) => {
  const {
    isSubmitting,
    isSubmitted,
  } = useScheduleDemoContext();
  const modalHeaderClasses = cn(styles.modalHeader, `tenant-header-${ tenant }`);

  const title = (
    <div className={ modalHeaderClasses }>
      <img
        className={ styles.backgroundImage }
        src={ waves.src }
        alt=""
      />
      <LogoComponent
        colorType={ ColorType.WHITE }
        className={ styles.logoImage }
      />
      <div className={ styles.modalHeaderTitle }>{ isSubmitted ? 'Demo Scheduled' : 'Schedule a Demo' }</div>
    </div>
  );

  return (
    <Modal
      hideOnOverlayClicked
      className={ styles.scheduleDemoModal }
      isVisible
      onCloseClicked={ closeModal }
      afterClose={ afterClose }
      dataTest={ `${ tenant }ScheduleDemoModal` }
      title={ title }
    >
      { isSubmitted && !isSubmitting
        ? <ScheduleDemoFormSuccess tenant={ tenant } />
        : (
          <>
            <div>
              <p className={ styles.contentDescription }>
                It takes 15-30 minutes and we operate on your availability.<br />
                Our team will send a meeting planner within twenty minutes as confirmation.
              </p>
            </div>
            <ScheduleDemoForm
              submitButtonClassName={ styles.submitButton }
              isSubmitting={ isSubmitting }
              tenant={ tenant }
              withLabels
              getInitialFormValues={ getInitialFormValues }
              defaultPhoneCountry={ defaultPhoneCountry }
              buttonTitle={ !isSubmitting ? <>Submit Request</> : (
                <span>
                  <Spinner size="S" color="on-color" className={ styles.spinner } />
                </span>
              ) }
            />
          </>
        ) }
    </Modal>
  );
};

export default (props: IProps) => (
  <ScheduleDemoContext>
    <ScheduleDemoModal { ...props } />
  </ScheduleDemoContext>
);
